<div
  class="page-wrapper"
  [class.page-wrapper--main]="isMainPage()"
  [class.page-wrapper--content]="!isMainPage()"
  [class.page-wrapper--mobile-menu-opened]="isMobileMenuOpened"
>
  <header class="header" [class.header--scrolled]="isScrolled">
    <div class="row pad">
      <div class="header__inner">
        <a
          [routerLink]="['/']"
          class="header__brand"
          (click)="closeMobileMenu()"
        >
          <img
            src="/logo.svg"
            alt="Mari Group live events experience"
            class="header__logo"
            width="136"
          />
        </a>

        <div class="header__toggle hide-medium">
          <div
            class="header__toggle-btn"
            [class.opened]="isMobileMenuOpened"
            (click)="toggleMobileMenu()"
          >
            <div class="bar1"></div>
            <div class="invis"></div>
            <div class="bar3"></div>
          </div>
        </div>

        <div class="header__container-inner">
          <nav class="header__nav">
            <ul
              class="header__menu"
              [class.header__menu--active]="isMenuPageValue"
            >
              @for (link of headerLinks; track $index) {
                <li class="header__menu-item">
                  <a
                    [routerLink]="[link.url]"
                    (click)="closeMobileMenu()"
                    class="header__menu-link"
                    routerLinkActive="header__menu-link--active"
                    >{{ link.title }}</a
                  >
                </li>
              }
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </header>

  <main class="page-content">
    <router-outlet />
  </main>

  <footer class="footer">
    <div class="footer__inner row pad">
      <div class="footer__top">
        <div class="footer__links">
          @for (link of footerLinks; track $index) {
            @if (!link.isExternal) {
              <a [routerLink]="[link.url]" class="footer__link">{{
                link.title
              }}</a>
            } @else {
              <a
                href="{{ link.url }}"
                class="footer__link"
                target="_blank"
                rel="noopener noreferrer"
                >{{ link.title }}</a
              >
            }
          }
        </div>
        <div class="footer__ask">
          <div class="footer__ask-label">Ask AI About MARI</div>
          <div class="footer__ai">
            <a
              href="https://chatgpt.com/?prompt={{ prompt }}"
              target="_blank"
              rel="noopener noreferrer"
              class="footer__ai-link footer__ai-link"
            >
              <img src="/ChatGPT.svg" alt="ChatGPT icon" />
            </a>
            <a
              href="https://claude.ai/new?q={{ prompt }}"
              target="_blank"
              rel="noopener noreferrer"
              class="footer__ai-link footer__ai-link"
            >
              <img src="/Claude.svg" alt="Claude AI icon" />
            </a>
          </div>
        </div>
        <div class="footer__social">
          @for (social of socialLinks; track $index) {
            <a
              href="{{ social.url }}"
              target="_blank"
              rel="noopener noreferrer"
              class="footer__social-link"
            >
              <img src="/{{ social.icon }}" alt="{{ social.title }} icon" />
            </a>
          }
        </div>
      </div>
      <div class="footer__bottom">
        <a [routerLink]="['/']" class="footer__brand hide-medium">
          <img
            src="/logo.svg"
            alt="Mari Group live events experience"
            class="footer__logo"
            width="115"
          />
        </a>
        <div class="footer__service-links hide-medium">
          @for (link of serviceLinks; track $index) {
            @if (link.isExternal) {
              <a
                href="{{ link.url }}"
                class="footer__link"
                target="_blank"
                rel="noopener noreferrer"
                >{{ link.title }}</a
              >
            } @else if (link.url !== undefined) {
              <a [routerLink]="[link.url]" class="footer__link">{{
                link.title
              }}</a>
            } @else {
              <span (click)="link.action()" class="footer__link">{{
                link.title
              }}</span>
            }
          }
        </div>
        <div class="footer__copy">
          &copy;{{ year }} MARI Group. All Rights Reserved.
        </div>
        <div class="footer__service-links hide-medium-down">
          @for (link of serviceLinks; track $index) {
            @if (link.isExternal) {
              <a
                href="{{ link.url }}"
                class="footer__link"
                target="_blank"
                rel="noopener noreferrer"
                >{{ link.title }}</a
              >
            } @else if (link.url !== undefined) {
              <a [routerLink]="[link.url]" class="footer__link">{{
                link.title
              }}</a>
            } @else {
              <span (click)="link.action()" class="footer__link">{{
                link.title
              }}</span>
            }
          }
        </div>
      </div>
    </div>
  </footer>
</div>
@if (isCookiesBarVisible) {
  <app-cookie-bar
    (openCookieSettings)="onCookieModalOpen()"
    (onCookiesAction)="setCookiesPreferences($event)"
  ></app-cookie-bar>
}
<app-cookie-settings
  [isOpen]="isCookieModalOpen"
  (modalClose)="onCookieModalClose($event)"
></app-cookie-settings>
